export function normalizeNumber(amount) {
	let currentValue = amount;
	//Numero finisce con la virgola
	if (amount.length > 0) {
		if (isNaN(currentValue.substr(currentValue.length - 1))) {
			currentValue = currentValue.substr(0,currentValue.length - 1);
			amount = currentValue;
		}
		else{
			let n = parseFloat(currentValue.replace(/,/g,"."));
			amount = n;
		}
	}
	else {
		amount = 0;
	}
	return amount;
}
